const HEADER_OPEN_CLASS = 'is-open';

function initTopMenu({
  header,
  toggle,
  nav,
}: {
  header: HTMLElement;
  toggle: HTMLButtonElement;
  nav: HTMLElement;
}) {
  const matchMedia = window.matchMedia('(min-width: 768px)');

  /**
   * ナビゲーション要素のアクセシビリティ属性を設定
   * デスクトップサイズでは常にアクセス可能、モバイルではメニューの開閉状態に応じて制御
   * @param isOpen メニューが開いているかどうか
   */
  function setNavAttributes(isOpen: boolean) {
    if (matchMedia.matches) {
      // PC表示時はダイアログ関連の属性を削除
      nav.removeAttribute('role');
      nav.removeAttribute('aria-modal');
      nav.removeAttribute('tabindex');
      nav.removeAttribute('inert');
      nav.removeAttribute('aria-hidden');
    } else {
      // モバイル表示時はダイアログとして機能
      nav.setAttribute('role', 'dialog');
      nav.setAttribute('aria-modal', 'true');
      nav.setAttribute('tabindex', '-1');
      nav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      if (isOpen) {
        nav.removeAttribute('inert');
      } else {
        nav.setAttribute('inert', '');
      }
    }
  }

  /**
   * トグルボタンのアクセシビリティ属性を設定
   * @param isOpen メニューが開いているかどうか
   */
  function setToggleAttributes(isOpen: boolean) {
    toggle.setAttribute(
      'aria-label',
      isOpen ? 'メニューを閉じる' : 'メニューを開く',
    );
  }

  /**
   * メニュー開閉時に他の要素の inert 属性を切り替え
   * メニューが開いている間は背景要素をフォーカス不可にする
   * @param isMenuOpen メニューが開いているかどうか
   * @see https://developer.mozilla.org/ja/docs/Web/API/HTMLElement/inert
   */
  function toggleInertElements(isMenuOpen: boolean) {
    document
      .querySelectorAll('[data-header-inert-target="true"]')
      .forEach((target) => {
        if (isMenuOpen) {
          target.setAttribute('inert', '');
        } else {
          target.removeAttribute('inert');
        }
      });
  }

  /**
   * メニューの初期状態を設定
   * ページ読み込み時やブレイクポイント変更時に呼び出される
   */
  function initMenuState() {
    setToggleAttributes(false);
    setNavAttributes(false);
    toggleInertElements(false);
  }

  /**
   * メニューを閉じた状態にリセット
   * ブレイクポイント変更時に呼び出される
   */
  function resetMenuState() {
    header.classList.remove(HEADER_OPEN_CLASS);
    toggle.classList.remove(HEADER_OPEN_CLASS);
    initMenuState();
  }

  /**
   * モバイル時のメニュー状態を更新
   * メニューの開閉に応じてアクセシビリティ属性を一括更新
   * @param isOpen メニューが開いているかどうか
   */
  function updateMobileMenuState(isOpen: boolean) {
    setToggleAttributes(isOpen);
    setNavAttributes(isOpen);
    toggleInertElements(isOpen);
  }

  /**
   * メニューを閉じる
   */
  function closeMenu() {
    header.classList.remove(HEADER_OPEN_CLASS);
    toggle.classList.remove(HEADER_OPEN_CLASS);
    updateMobileMenuState(false);
  }

  /**
   * メニュー表示状態を切り替え
   * CSSクラスの切り替えとアクセシビリティ属性の更新を行う
   */
  function toggleState() {
    header.classList.toggle(HEADER_OPEN_CLASS);
    toggle.classList.toggle(HEADER_OPEN_CLASS);

    const isOpen = header.classList.contains(HEADER_OPEN_CLASS);

    updateMobileMenuState(isOpen);

    // ダイアログが開いた時にフォーカスを移動
    if (isOpen) {
      (nav as HTMLElement).focus();
    }
  }

  matchMedia.addEventListener('change', resetMenuState);

  toggle.addEventListener('click', function () {
    if (matchMedia.matches) {
      return;
    }

    toggleState();
  });

  // ESCキーでダイアログを閉じる
  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      header.classList.contains(HEADER_OPEN_CLASS)
    ) {
      closeMenu();
    }
  });

  initMenuState();
}

// ハンバーガーメニュー
function addMenuToggleEvent() {
  const header = document.querySelector('#js-header');
  const headerTop = document.querySelector<HTMLElement>('#js-header-top');
  const headerTopNav = document.querySelector<HTMLElement>('#top-header-nav');
  const toggle = document.querySelector<HTMLButtonElement>('#js-toggle');

  if (header && toggle) {
    toggle.addEventListener('click', function () {
      header.classList.toggle(HEADER_OPEN_CLASS);
      toggle.classList.toggle(HEADER_OPEN_CLASS);
    });
  } else if (headerTop && toggle && headerTopNav) {
    initTopMenu({ header: headerTop, toggle, nav: headerTopNav });
  }
}

window.addEventListener('DOMContentLoaded', addMenuToggleEvent);
